import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../../lib/reveal";

const HomeVideo = () => (
  <section data-testid="home-video-section" className="bg-bati-mist py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <div className="grid items-center gap-12 lg:grid-cols-2">
        <Reveal>
          <p className="mb-4 flex items-center gap-3 text-[12px] font-bold uppercase tracking-[0.22em] text-bati-sky">
            <span className="h-px w-10 bg-bati-sky" /> En immersion
          </p>
          <h2 className="font-display text-4xl font-extrabold tracking-tight text-bati-ink sm:text-5xl">
            Nos chantiers en vidéo
          </h2>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-bati-ink/60">
            Surélévation en ossature bois, toiture zinc, étanchéité : nos chantiers filmés sur le terrain, de la structure aux finitions.
          </p>
          <Link
            to="/videos"
            data-testid="home-videos-link"
            className="group mt-8 inline-flex items-center gap-3 bg-bati-blue px-8 py-4 text-[13px] font-bold uppercase tracking-[0.12em] text-white transition-colors duration-300 hover:bg-bati-sky"
          >
            Voir toutes les vidéos
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mx-auto max-w-[380px] overflow-hidden border border-black/10 bg-black">
            <video
              data-testid="home-video"
              src="/chantiers/surelevation/chantier-video.mp4"
              poster="/chantiers/surelevation/chantier-video-poster.webp"
              controls
              playsInline
              preload="metadata"
              className="h-auto w-full"
            >
              Votre navigateur ne prend pas en charge la lecture vidéo.
            </video>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default HomeVideo;
